export const LIST = "SLOT_FREE_SPIN_LIST";
export const DROPDOWN = "SLOT_FREE_SPIN_DROPDOWN";
export const STORE = "SLOT_FREE_SPIN_STORE";
export const GET_FREE_SPIN_MEMBER = "SLOT_FREE_SPIN_GET_FREE_SPIN_MEMBER";
export const ADD_FREE_SPIN_MEMBER = "SLOT_FREE_SPIN_ADD_FREE_SPIN_MEMBER";
export const SHOW = "SLOT_FREE_SPIN_SHOW";
